import { Col, Row } from "antd";
import { Image } from "antd-mobile";
import { Trans, useTranslation } from "react-i18next";
import localStorageKey from "../../../../../../../enumerations/localStorageKey";
import { moneyFormat } from "../../../../../../../plugins/numberFormat";
import { envChangeType } from "../../../../../../../plugins/utils";
import { useGetDepositReabateRate } from "../../../../hooks/comissionreport.hooks";
import styles from "./style.module.scss";

const SAMPLE_AMOUNT = 1000;

const parseDepositBonusLevels = (rawRate) => {
  if (rawRate == null || rawRate === "") return [];

  if (typeof rawRate === "number" && !Number.isNaN(rawRate)) {
    return [{ level: 1, bonus: rawRate }];
  }

  let parsed = rawRate;
  if (typeof rawRate === "string") {
    try {
      parsed = JSON.parse(rawRate.trim());
    } catch {
      const numericRate = Number(rawRate);
      return Number.isNaN(numericRate) ? [] : [{ level: 1, bonus: numericRate }];
    }
  }

  const levels = Array.isArray(parsed) ? parsed : parsed?.levels;
  if (!Array.isArray(levels)) return [];

  return levels
    .map((item, index) => ({
      level: Number(item?.level) || index + 1,
      bonus: Number(item?.bonus) || 0,
    }))
    .sort((a, b) => a.level - b.level);
};

const DepositRebate = () => {
  const { t } = useTranslation();
  const { data: depositRebate } = useGetDepositReabateRate({});
  const depositBonusLevels = parseDepositBonusLevels(depositRebate?.agent_deposit_bonus_rate);
  const currency =
    localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
    envChangeType("REACT_APP_DEFAULT_CURRENCY");

  const getLevelLabel = (level) =>
    t([`comission.category.tier${level}`, `promotion.active.levels.${level}`], {
      defaultValue: `Lv.${level}`,
    });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.contentShadow}>
          <div
            className={styles.title1}
            dangerouslySetInnerHTML={{ __html: t("comission.depositRebate.title1") }}
          />
          <div
            className={styles.title2}
            dangerouslySetInnerHTML={{ __html: t("comission.depositRebate.title2") }}
          />
        </div>
        <div className={styles.content}>
          <div
            className={styles.title1}
            dangerouslySetInnerHTML={{ __html: t("comission.depositRebate.title1") }}
          />
          <div
            className={styles.title2}
            dangerouslySetInnerHTML={{ __html: t("comission.depositRebate.title2") }}
          />
        </div>
        <Image
          className={styles.background}
          src={`/images/comission/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/deposit-header.png`}
          fallback={
            <Image
              src={`/images/comission/default/deposit-header.png`}
              className={styles.background}
              placeholder={false}
            />
          }
        />
      </div>
      <div className={styles.middleContainer}>
        <div className={styles.bgGradient}>
          <div className={styles.contentTitle}>{t("comission.depositRebate.content.title")}</div>
        </div>
      </div>
      <Row gutter={[5, 12]} className={styles.bottomContainer}>
        <Col span={12}>
          <div className={styles.bottomContent}>
            <div className={styles.title}>{t("comission.ratio.title")}</div>
            <div className={styles.subtitle}>{t("comission.depositRebate.ratesubtitle")}</div>
            {depositBonusLevels.length > 0 ? (
              <div className={styles.rateList}>
                {depositBonusLevels.map((item) => (
                  <div className={styles.rateRow} key={item.level}>
                    <span className={styles.rateLevel}>{getLevelLabel(item.level)}</span>
                    <span className={styles.rateValue}>{`${item.bonus}%`}</span>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.value}>0%</div>
            )}
          </div>
        </Col>
        <Col span={12}>
          <div className={styles.bottomContent}>
            <div className={styles.title}>{t("comission.depositRebate.settleTime")}</div>
            <div className={`${styles.value} ${styles.perDay}`}>
              {t("comission.depositRebate.perDay")}
            </div>
          </div>
        </Col>
        <Col span={24}>
          <div className={styles.bottomContent}>
            <div className={styles.remark}>
              <Trans i18nKey={"comission.depositRebate.hint"} />
            </div>
          </div>
        </Col>
      </Row>
      <div className={styles.example}>
        <div>
          {t("comission.depositRebate.ratesampleIntro", {
            amount: SAMPLE_AMOUNT,
            currency,
          })}
        </div>
        {depositBonusLevels.map((item) => (
          <div className={styles.exampleItem} key={item.level}>
            {t("comission.depositRebate.ratesampleLevel", {
              level: getLevelLabel(item.level),
              percent: item.bonus,
              bonus: moneyFormat((item.bonus / 100) * SAMPLE_AMOUNT),
              currency,
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DepositRebate;
